module.exports = __webpack_public_path__ + "static/media/porto-alegre-rs.62593ac5.jpg";